import api from "./api";

export type RequestReasonProps = {
    id?: number;
    reason: string;
    status: "ativo" | "inativo";
};

const RequestReason = {
    async list() {
        return api.get(`/v1/request/reasons`).then((res) => res.data);
    },
};

export default RequestReason;
